(function (ng) {
    ng.module('evo.Compare.Filters').filter('discountMessage', function () {
        return function (priceStatus) {
            switch (priceStatus) {
                case 'Full': return null;
                case 'LimitedTime': return 'Limited Time';
                default: return priceStatus;
            }
        };
    });
})(angular);